import * as React from "react";
const SvgArrowCircleBrokenRight = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 12A8.965 8.965 0 0 0 4.233 7.519a1.035 1.035 0 0 1-1.79-1.038A11.03 11.03 0 0 1 12 .965c6.095 0 11.035 4.94 11.035 11.035S18.095 23.035 12 23.035a11.03 11.03 0 0 1-9.558-5.516 1.035 1.035 0 0 1 1.791-1.038A8.965 8.965 0 0 0 20.964 12m-9.696-4.731a1.034 1.034 0 0 1 1.462 0l4 4a1.035 1.035 0 0 1 0 1.462l-4 4a1.034 1.034 0 1 1-1.462-1.462l2.233-2.234H2a1.035 1.035 0 0 1 0-2.07h11.502L11.269 8.73a1.034 1.034 0 0 1 0-1.462"
}));
export default SvgArrowCircleBrokenRight;
//# sourceMappingURL=ArrowCircleBrokenRight.js.map